<template>
  <div class="card flex justify-center">
    <p class="mr-2 dark:text-white">{{ isChecked ? 'Modo Light' : 'Modo Oscuro' }}</p>
    <ToggleSwitch v-model="isChecked" @change="toggleDarkMode" />
  </div>
</template>

<script setup>
const isChecked = ref(true);
const tstore = useThemeStore();

onBeforeMount(() => {
  isChecked.value = tstore.currentTheme === 'light';
});

function toggleDarkMode() {
  const dark = document.documentElement.classList.toggle('dark');
  const theme = dark ? 'dark' : 'light';
  tstore.setTheme(theme);
}

</script>
